import '../scss/calendarium.scss';

require.context('calendarium/src/images', false, /\.(png|svg|jpe?g|gif)$/);

window.bLazy;
$(() => {
  $(document).foundation();
  window.bLazy = new Blazy({
    offset: 10
  });
});

const rawMaterialSelect = document.querySelector('#rawMaterialSelectionSelect');
const rawMaterialSelectSubmit = document.querySelector('#rawMaterialSelectSubmit');

if (rawMaterialSelect) {
  rawMaterialSelect.addEventListener('change', e => {
    rawMaterialSelectSubmit.click();
  });
}

window.addEventListener('load', e => {
  $("#status").fadeOut();
  $("#preloader").delay(250).fadeOut("slow");
});